import React from 'react';
import { Link } from 'react-router-dom';
import './DeliveryInfo.css';

// Delivery information block. Shown on every product page (compact) and on the
// /delivery page (with the full three-zone breakdown). The two-person wording
// is deliberately about RECEIVING the unit and is kept distinct from the
// installation manpower in our manual (2 to install, 3+ from 4 m wide).
//
// `headingLevel` is the level the block's title should take where it sits:
// 3 under a product page's h2 sections (default), 2 on the /delivery page
// where it follows the h1 directly.
export default function DeliveryInfo({ showZones = false, headingLevel = 3 }) {
  const Title = `h${headingLevel}`;
  return (
    <div className="delivery-info">
      <Title className="delivery-info-title">Delivery</Title>

      {showZones && (
        <ul className="delivery-info-zones">
          <li><strong>Free</strong> - most of Melbourne: metro west, inner, and south-east out to Dandenong.</li>
          <li><strong>$150 flat</strong> - outer Melbourne and the near-regional edge, up to (not beyond) Pakenham and Torquay.</li>
          <li><strong>Quoted separately</strong> - everywhere else in Australia, including interstate. We confirm the freight cost with you before charging.</li>
        </ul>
      )}

      <ul className="delivery-info-points">
        <li>We deliver Melbourne orders ourselves and use freight carriers for the rest of Australia.</li>
        <li>Delivery is to the door. A signature is required, so someone needs to be home to accept the order.</li>
        <li>Units over 3 metres in width or projection need <strong>two people on hand to receive them</strong> - to lift and move the unit safely off the vehicle.</li>
        <li>Receiving is separate from installation. Fitting the unit needs at least two people, and three or more for units 4 metres wide or more; those requirements are covered in the installation manual.</li>
      </ul>

      {!showZones && (
        <p className="delivery-info-link"><Link to="/delivery">Full delivery details and zones →</Link></p>
      )}
    </div>
  );
}
